import { useEffect, useMemo, useState } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { getAssignmentAuditLogs } from './functions/get_audit_logs.function';
import styles from '../RoleAssignment/role_assignment.module.css';
import { getRoleAssignmentTableBaseOptions } from '../RoleAssignment/role_assignment_table.utils';
import { RoleAssignmentTableShell } from '../RoleAssignment/role_assignment_table_shell.component';
import { RoleAssignmentSearchToolbar } from '../RoleAssignment/role_assignment_search_toolbar.component';

const cellText = (value, muted = false) => (
  <span style={{ fontSize: '14px', color: muted ? '#667085' : '#1D242E' }}>{value || 'N/A'}</span>
);

export const SystemInvoiceApproverAuditLogs = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const data = await getAssignmentAuditLogs({ limit: 200 });
      setRows(Array.isArray(data) ? data : []);
      setLoading(false);
    };
    load();
  }, []);

  const filteredRows = useMemo(() => {
    if (!searchTerm) {
      return rows;
    }
    const q = searchTerm.toLowerCase();
    return rows.filter((row) =>
      Object.values(row).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(q)
      )
    );
  }, [rows, searchTerm]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'event_type',
        header: 'Event',
        size: 140,
        enableColumnActions: false,
        Cell: ({ cell }) => cellText(cell.getValue()),
      },
      {
        accessorKey: 'action_type',
        header: 'Action',
        size: 120,
        enableColumnActions: false,
        Cell: ({ cell }) => cellText(cell.getValue(), true),
      },
      {
        accessorKey: 'performed_by_name',
        header: 'By',
        size: 150,
        enableColumnActions: false,
        Cell: ({ cell }) => cellText(cell.getValue()),
      },
      {
        accessorKey: 'performed_by_email',
        header: 'Email',
        size: 220,
        enableColumnActions: false,
        Cell: ({ cell }) => cellText(cell.getValue(), true),
      },
      {
        accessorKey: 'comment',
        header: 'Comment',
        size: 200,
        enableColumnActions: false,
        Cell: ({ cell }) => cellText(cell.getValue(), true),
      },
      {
        accessorKey: 'created_at',
        header: 'When',
        size: 180,
        enableColumnActions: false,
        Cell: ({ cell }) =>
          cellText(cell.getValue() ? new Date(cell.getValue()).toLocaleDateString() : '—', true),
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    ...getRoleAssignmentTableBaseOptions({
      initialState: {
        pagination: { pageSize: 10 },
        sorting: [{ id: 'created_at', desc: true }],
      },
      enableSorting: true,
    }),
    columns,
    data: filteredRows,
    state: { isLoading: loading },
    renderTopToolbarCustomActions: () => (
      <RoleAssignmentSearchToolbar searchTerm={searchTerm} onSearchChange={setSearchTerm} />
    ),
  });

  return (
    <div className={styles['role-assignment-container']} style={{ padding: 0 }}>
      <h2 className={styles['invoice-approver-section-title']}>Assignment audit history</h2>
      <RoleAssignmentTableShell>
        <MaterialReactTable table={table} />
      </RoleAssignmentTableShell>
    </div>
  );
};
